module.exports = __webpack_public_path__ + "static/ticketcorner-3f71fb27d4081f6676b945919fd0a522.jpg";